/**
 * Quill 2 stores bullet and ordered lists as `<ol><li data-list="bullet|ordered">`.
 * Browsers ignore `data-list`, so bullets render as numbers unless converted to `<ul>` / `<ol>`.
 */

function liListType(li, parentTag) {
  const dataList = String(li.getAttribute('data-list') || '').trim().toLowerCase();
  if (dataList === 'bullet' || dataList === 'unchecked' || dataList === 'checked') return 'ul';
  if (dataList === 'ordered') return 'ol';
  return parentTag === 'UL' ? 'ul' : 'ol';
}

function convertQuillListElement(list) {
  const items = Array.from(list.children).filter((node) => node.tagName === 'LI');
  if (!items.length) return;

  const needsConversion = items.some((li) => li.hasAttribute('data-list'));
  if (!needsConversion) return;

  const parent = list.parentNode;
  if (!parent) return;

  const doc = list.ownerDocument;
  const newLists = [];
  let currentList = null;
  let currentType = null;

  const startList = (type) => {
    currentType = type;
    currentList = doc.createElement(type);
    newLists.push(currentList);
  };

  for (const li of items) {
    const type = liListType(li, list.tagName);
    if (!currentList || currentType !== type) startList(type);
    li.removeAttribute('data-list');
    currentList.appendChild(li);
  }

  const anchor = list;
  for (const nl of newLists) parent.insertBefore(nl, anchor);
  parent.removeChild(list);
}

/**
 * @param {string} html
 * @returns {string}
 */
export function quillListsToSemanticHtml(html) {
  if (!html || typeof html !== 'string') return html;
  if (!/<li\b/i.test(html) || !/data-list\s*=/i.test(html)) return html;
  if (typeof DOMParser === 'undefined') return html;

  const doc = new DOMParser().parseFromString(`<div id="quill-root">${html}</div>`, 'text/html');
  const root = doc.getElementById('quill-root');
  if (!root) return html;

  const lists = Array.from(root.querySelectorAll('ol, ul'));
  lists.reverse().forEach((list) => convertQuillListElement(list));

  return root.innerHTML;
}
